/* eslint-env browser */

const fb = function (e = window.event) { // eslint-disable-line no-unused-vars
  const { target } = e
  const metaHref = document.querySelector('meta[name=host]').getAttribute('content')
  const href = metaHref + target.getAttribute('data-href')
  FB.ui({ // eslint-disable-line no-undef
    method: 'share',
    display: 'popup',
    href,
  }, response => {}) // eslint-disable-line no-unused-vars
}
